import React from "react";
import HomeBg from "../../../certificates/HomeNew.jpg";
const UserDetails = ({ userInfo, area, image }) => {
  let serial = 1;
  return (
    <div>
      <p className="fs-3 mb-0 fw-bold mt-4">Quotation Details For:</p>

      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "30%" }}>Item</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{serial++}</td>
            <td>Contact Details</td>
            <td>{`M/s. ${userInfo.contactPersonName}` || "N/A"}</td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Business Details</td>
            <td>
              Name:{`${userInfo?.businessName}` || "N/A"} GST:{" "}
              {`${userInfo?.gstNumber}` || "N/A"}
            </td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Site location</td>
            <td>{`${userInfo?.address}` || "N/A"}</td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Construction size</td>
            <td>
              {`Bay:${
                userInfo?.bay_size ? `${userInfo?.bay_size}Mtr` : "N/A"
              }, Span:${
                userInfo?.span_size ? `${userInfo?.span_size}Mtr` : "N/A"
              }, Area: ${
                area?.area_in_sqmeter ? `${area?.area_in_sqmeter}SqMtr` : "N/A"
              } ${area?.area_in_sqft ? `(${area?.area_in_sqft}SqFt)` : ""}`}
            </td>
          </tr>

          {userInfo?.quotationType !== "hydroponics only" &&
            userInfo?.quotationType !== "fanpad" &&
            userInfo?.quotationType !== "nvph" &&
            userInfo?.quotationType !== "nethouse" &&
            userInfo?.quotationType !== "soilbasedfanpad" &&
            userInfo?.quotationType !== "soilbasednvph" &&
            userInfo?.quotationType !== "soilbasednethouse" && (
              <tr>
                <td>{serial++}</td>
                <td>Hydroponic Percentage</td>
                <td>
                  {`A-frame:${userInfo?.a_FramePercent || 0}%, Flat-NFT:${
                    userInfo?.flatBedPercent || 0
                  }%, Grow bag:${
                    userInfo?.growBagPercent || 0
                  }%, Dutch Bucket:${userInfo?.dutchBucketPercent | 0}%` ||
                    "N/A"}
                </td>
              </tr>
            )}
        </tbody>
      </table>
      {/* {image != "visible" ? (
        <div style={{ width: "100%" }}>
          <img
            src={
              "https://res.cloudinary.com/dsmabnook/image/upload/v1749639059/hthd_wfcbvp_l9knae.png"
            }
            width={"100%"}
            alt="kryzenCertificates"
          />
        </div>
      ) : (
        ""
      )} */}
      <div
        className="p-4 ps-2"
        style={{
          marginTop: "120px",
        }}
      >
        <h3
          style={{
            fontSize: "3.3rem",
            // boxShadow:
            //   "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset",
          }}
          className="pb-3"
        >
          India's Largest
        </h3>
        <h3 style={{ fontSize: "3.3rem" }} className="pb-3">
          <span style={{ color: "green" }}>Greenhouse / Polyhouse</span> <br />
        </h3>
        <h3 style={{ fontSize: "3.3rem" }}> Manufacturer!</h3>
      </div>
      {/* {image != "visible" ? ( */}
      <div style={{ width: "100%" }}>
        <img src={HomeBg} width={"100%"} alt="kryzenCertificates" />
      </div>
      {/* ) : (
        ""
      )} */}
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
    </div>
  );
};

export default UserDetails;
